import { render } from "./BgConstructorFloors.vue?vue&type=template&id=44ed2311&ts=true"
import script from "./BgConstructorFloors.vue?vue&type=script&lang=ts"
export * from "./BgConstructorFloors.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/azhukovets/.nps/caiman_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__